import { useState } from 'react'
import { Input } from './input'

export function MoneyInput({
  value,
  onChange,
}: {
  value: number | null
  onChange: (v: number | null) => void
}) {
  const [focused, setFocused] = useState(false)
  const [raw, setRaw] = useState('')

  const formatted =
    value != null ? (value / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : ''

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
        R$
      </span>
      <Input
        type="text"
        inputMode="decimal"
        className="pl-8"
        placeholder="0,00"
        value={focused ? raw : formatted}
        onFocus={() => {
          setRaw(value != null ? String(value / 100) : '')
          setFocused(true)
        }}
        onChange={(e) => setRaw(e.target.value)}
        onBlur={() => {
          const parsed = parseFloat(raw.replace(',', '.'))
          onChange(isNaN(parsed) ? null : Math.round(parsed * 100))
          setFocused(false)
        }}
      />
    </div>
  )
}
